<template>
<div>
  <div class="box">
    <div class="title">{{$t('common.welcomeMag')}}</div>
    <img src="../../assets/images/homebg.png" alt="">
    <div class="btn" v-if="this.$store.state.dict.currentMeetingCode">
      <el-button type="primary" size="mini" @click="enterClick()">{{$t('common.goMeet')}}</el-button>
    </div>
  </div>

</div>
</template>

<script>
export default {
  methods:{
    enterClick(){
      localStorage.setItem('previewPage',false);
      this.$router.push('/index/' + this.$store.state.dict.currentMeetingCode)
    }
  }
}
</script>

<style scoped lang="scss">
.box{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90%;
  height: 600px;
  img{
    width:285px;
    height: 285px;
  }
  .title{
    font-size: 18px;
    color: #595959;
    margin-bottom: 70px;
  }
  .btn{
    margin-top:40px;
    .el-button{
      padding: 20px;
      font-size: 16px;
    }
  }
}

</style>
